export default __webpack_public_path__ + "static/media/homeBgTop.67e6f164.png";